<!-- 媒体卡片，图片，视频， iframe -->
<template>
  <div
    class="v-media-card"
    :class="{
      'v-media-card--height-scale': heightScale > 0,
    }"
    :style="
      heightScale && {
        paddingBottom: `${heightScale}%`,
      }
    "
  >
    <template v-if="src">
      <!-- 用户上传视频 -->
      <v-video-player
        v-if="type === 'video'"
        :poster="thumbnail"
        :src="videoSrc"
        :video-src="src"
        :muted="muted"
        :show-play-button="showPlayButton"
        :autoplay="autoplay"
        class="v-media-card__media"
        :class="[themeStyleRadius == 'circle' ? 'image-radius' : '']"
      />

      <!-- youtube视频 -->
      <div v-else-if="type === 'external_video'" class="v-media-card__iframe-wrapper" :class="[themeStyleRadius == 'circle' ? 'image-radius' : '']">
        <iframe
          class="v-media-card__media"
          :src="videoSrc"
          :video-src="src"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        >
        </iframe>
      </div>

      <!-- 普通图片 -->
      <div v-else class="v-media-card__media">
        <v-lazy-img  :image-fillet="themeStyleRadius" :src="thumbnail" :data-url="url" :data-src="src" @load="handleImageLoad" />
      </div>
    </template>
    <div v-else class="v-media-card__media">
      <v-lazy-img :image-fillet="themeStyleRadius" class="v-media-card__media" :dara-src="null" />
    </div>
  </div>
</template>

<script>
import videoPlayer from '@/js/components/VideoPlayer.vue'
//import LazyImg from './LazyImg.vue'
import { quertDataToUrl, urlToQueryData } from '../lib/util'
import { mapState } from 'vuex'

export default {
  name: 'vMediaCard',
  components: {
    //LazyImg,
    [videoPlayer.name]: videoPlayer,
  },
  props: {
    // 媒体地址，或图片地址
    url: {
      type: String,
      default: null,
    },
    src: {
      type: String,
      default: null,
    },
    // thumbnail 缩略图
    thumbnail: {
      type: String,
      default: null,
    },
    srcset: {
      type: String,
      default: null
    },
    // medium 中等图，视频的话，可用于封面
    medium: {
      typy: String,
      default: null,
    },
    // 媒体类型，image， video， iframe
    type: {
      type: String,
      require: true,
    },
    // 默认播放，针对视频有效
    autoplay: {
      type: Boolean,
      default: false,
    },
    // 静音播放，针对视频有效
    muted: {
      type: Boolean,
      default: false,
    },
    // 展示播放按钮，针对视频有效
    showPlayButton: {
      type: Boolean,
      default: true,
    },
    // 高度比例，1 ~ 100; 100表示正方形
    heightScale: {
      type: Number,
      default: null,
    },
  },
  methods: {
    // 图片加载完成事件
    handleImageLoad(fun) {
      this.$emit('imageLoad', fun)
    }
  },
  // 计算
  computed: {
    videoSrc() {
      // 如果是youtube的视频
      let videoSrc = null
      if (this.type === 'external_video') {
        const params = urlToQueryData(this.src)

        const { path, query } = params

        const newParams = {
          path,
          query: {
            ...query,
            autoplay: this.autoplay ? 1 : 0,
            mute: this.muted ? 1 : 0,
          },
        }

        videoSrc = quertDataToUrl(newParams)
      }

      if (this.type === 'video') {
        videoSrc = this.src
      }

      return videoSrc
    },
    ...mapState({
       themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    }),
  },
}
</script>

<style lang="scss" scoped>
.v-media-card {
  min-height: 200px;
  &__media {
    img, video {
      max-width: 100%;
    }
  }
  &__iframe-wrapper {
    width: 100%;
    max-width: 100vw;
    height: 0;
    padding-bottom: 80%;
    position: relative;
    iframe {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 2;
      top: 0;
      left: 0;
    }
  }
  &--height-scale {
    position: relative;
    .v-media-card {
      &__media {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        &::v-deep {
          video,
          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
        }
      }
      &__iframe-wrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        padding-bottom: 0;
        iframe {
          height: 100%;
          width: 100%;
          position: static;
        }
      }
    }
  }
}
</style>
